<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;"> 
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="common.page = 1;changeSchool()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> 
                </div>
                <div style="display: inline-block; height:40px; margin-left: 20px;" v-if="isShow"> 
                    <el-radio-group v-model="form.corpApplay" @change="changeCorpApplay">
                        <el-radio :label="1">企业内部应用</el-radio>
                        <el-radio :label="2">第三方企业应用</el-radio>
                    </el-radio-group>
                </div>
                <div style="display: inline-block; height:40px;float: right;" v-if="form.corpApplay == 1">
                    <el-button type="primary" @click="setAddLinux()" v-if="isShow">上传Linux应用</el-button>
                    <el-button type="primary" @click="setAddWindow()" v-if="isShow">上传Window应用</el-button>
                </div>
                <!-- <div style="display: inline-block; height:40px;float: right;" v-if="form.corpApplay == 2">
                    <el-button type="primary" @click="setAdd()" v-if="isShow">上传第三方企业应用</el-button>
                </div> -->
            </div>

             <el-table
                :data="data"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                v-if="form.corpApplay == 1">
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="applyVersion"  label="应用版本"  :show-overflow-tooltip="true" width="130">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 2 ">
                            {{scope.row.applyVersion}}<span style="color:red;">(此版本正在用)</span>
                        </div>
                        <div v-else>
                            {{scope.row.applyVersion}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="操作系统" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1 ">Windows</div>
                        <div v-else>Linux</div>
                    </template>
                </el-table-column>
                <el-table-column label="软件类型" width="100">内部企业应用</el-table-column>
                <el-table-column prop="fileSize" label="应用大小(字节)" :show-overflow-tooltip="true"  width="110"></el-table-column>
                <el-table-column prop="remark" label="版权说明"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" width="140"></el-table-column>
                <el-table-column prop="" label="下线时间" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.gmtModified != '' && scope.row.gmtModified != null">
                            {{scope.row.gmtModified}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 1 && isShow">
                           <el-button  @click.native.prevent="releaseVersion(scope.row.id,2)"
                                        type="primary">
                                        发布
                            </el-button>
                            <el-button  @click.native.prevent="del(scope.row.id)" style="margin-top:5px;"
                                type="danger">
                                删除
                            </el-button>
                        </div>
                        <div v-else-if="scope.row.applyStatus == 3 && isShow">
                            <el-button  @click.native.prevent="rollBackVersion(scope.row.id,2)"
                                        type="primary">
                                        回滚到此版本
                            </el-button>
                        </div>
                        <div v-else-if="scope.row.applyStatus == 2">
                            <el-button  type="danger" @click.native.prevent="offApply(scope.row.id)" v-if="isShow">下架</el-button>
                            <el-button type="primary" style="margin-top:5px;">
                                <a :href="scope.row.fullApplyUrl" target="_blank">下载</a>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="form.corpApplay == 1">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
            

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" 
                v-loading="loading"
                :element-loading-text="loadingText" 
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)" 
                row-key="id" border default-expand-all
                v-if="form.corpApplay == 2"
                >

                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="applyVersion" label="应用版本" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 2">
                            {{ scope.row.applyVersion }}<span style="color:red;">(此版本正在用)</span>
                        </div>
                        <div v-else>
                            {{ scope.row.applyVersion }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="软件类型" width="110">第三方企业应用</el-table-column>
                <el-table-column label="更新功能" prop="remark" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column>
                <el-table-column label="升级范围" prop="rangeVal" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gmtCreate"  label="发布时间" show-overflow-tooltip width="150px;"></el-table-column>
                <el-table-column prop="" label="下架时间" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.gmtModified != '' && scope.row.gmtModified != null">
                            {{ scope.row.gmtModified }}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.prevent="applySet(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <!-- 新增/修改Window弹出框 -->
        <div v-if="addWindowVisible">
            <addWindow ref="addWindow"></addWindow>
        </div>
        <!-- 新增/修改Linux弹出框 -->
        <div v-if="addLinuxVisible">
            <AddLinux ref="addLinux"></addLinux>
        </div>
        <!-- 应用设置-->
        <apply-set v-model="applySetVisible" :applyId="applyId" :isShow="false" />
    </div>
</template>

<script>
    import http from '../../../common/http';
    import addWindow from './AddWindow.vue';
    import AddLinux from './AddLinux.vue';
    import applySet from "./thirdApply/components/applySet.vue";

    export default {
        name:"ApplyManage",
        data(){
            return{
                menuName:"",
                loading: false,
                loadingText: "",
                addWindowVisible:false,
                addLinuxVisible:false,
                applySetVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    applyStatus:"",
                    deptId:"",
                    corpApplay: 1,
                },
                isShow:false,
                depts:[],
                data:[],
                // 传递的参数
                applyId:"",
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key")
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'))
            // 如果id为1的话，表示管理员，管理才能上传或者回滚此应用及拷贝
            if(userinfo.id == 1){
                this.isShow=true
            }else{
                this.isShow=false
            }
            this.data = []
            // 获取学校列表
            this.getDeptData()
        },
        components: {
            addWindow, AddLinux, applySet
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        // 查询选中的企业
                        this.getCorpApplay()
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取企业应用
            getCorpApplay(){
                let url  = this.applyManageGetCorpCLassRoomApplyUrl;
                let data = {
                    deptId: this.form.deptId
                }
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        if(this.$util.isEmpty(res.data)){
                            this.form.corpApplay = 1
                        }else{
                            this.form.corpApplay = res.data
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }

                    console.log('corpApplay', this.form.corpApplay)
                    // 查询数据
                    this.getData();
                },(err)=>{
                    console.log(err)
                });
            },
            // 更改企业应用值
            changeCorpApplay(){
                let url  = this.applyManageUpdateCorpCLassRoomApplyUrl;
                let data = {
                    deptId: this.form.deptId,
                    corpApplay: this.form.corpApplay
                }
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 查询数据
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            // 学校改变
            changeSchool(){
                // 获取企业应用
                this.getCorpApplay()
            },
            getData(){
                this.data = []
                this.loading=true;
                this.loadingText="数据加载中...";
                // 企业内部应用
                if(this.form.corpApplay === 1){
                    let url  = this.applyManageListUrl;
                    let data = {
                        isPage:this.common.isPage,
                        page:this.common.page,
                        limit:this.common.pageSize,
                        deptId:this.form.deptId,
                        type: '1,4', // 应用类型（1-Widnow桌面应用，2-Android移动应用，3-Mac桌面应用，4-Linux桌面应用）
                    };

                    this.apiPost(url,data).then((res) => {
                        if(res.status==200){
                            this.data = res.data.list
                            this.common.total=res.data.total

                            // 不是管理员进来，只能看到已发布的数据
                            if(!this.isShow){   
                                let release=[];
                                for(let i=0;i<this.data.length;i++){
                                    let v=this.data[i];
                                    if(v.applyStatus == 2){
                                        release.push(v)
                                    }
                                }
                                this.data=release
                            }
                        }else{
                            this.$commonFn.showTip(res.message,3)
                        }
                        this.loading=false
                    },(err)=>{
                        console.log(err)
                        this.loading=false
                    });
                }// 第三方企业应用
                else if(this.form.corpApplay === 2){
                    let url = this.thirdApplyManageListUrl;
                    let data = {
                        isPage: this.common.isPage,
                        page: this.common.page,
                        limit: this.common.pageSize,
                        type: 1, // 应用类型（1-桌面应用，2-Android应用，3-苹果应用）
                        applyStatus: 2 // 应用状态（1-待发布，2-正在使用版本，3-历史版本）
                    };
                    // console.log(JSON.stringify(data))
                    // return;
                    this.apiPost(url, data).then((res) => {
                        if (res.status == 200) {
                            this.data = res.data.list;

                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                        this.loading=false
                    }, (err) => {
                        this.loading=false
                    });
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增Window界面
            setAddWindow(){
                this.addWindowVisible=true;
                this.$nextTick(() => {
                    this.$refs['addWindow'].init(this.form.deptId);
                })
            },
            //新增Linux界面
            setAddLinux(){
                this.addLinuxVisible=true;
                this.$nextTick(() => {
                    this.$refs['addLinux'].init(this.form.deptId);
                })
            },
            //删除
            del(id){
                this.form.id =id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.applyManageRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            releaseVersion(id,applyStatus){
                let msg="发布此版本，将覆盖正在使用的版本，是否继续？";
                this.form.id=id;
                this.form.applyStatus=applyStatus;
                this.$commonFn.showConfirm2(msg,this.updateSuccess);
            },
            rollBackVersion(id,applyStatus){
                let msg="回滚此版本，将覆盖正在使用的版本，是否继续？";
                this.form.id=id;
                this.form.applyStatus=applyStatus;
                this.$commonFn.showConfirm2(msg,this.updateSuccess);
            },
            updateSuccess(){
                let url = this.applyManageUpdateUrl;
                let data = {
                    id:this.form.id,
                    applyStatus:this.form.applyStatus
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            offApply(id){
                let msg="确定下架此版本吗？";
                this.form.id=id;
                this.$commonFn.showConfirm2(msg,this.offApplySuccess);
            },
            offApplySuccess(){
                let url = this.applyManageOffUrl;
                let data = {
                    id:this.form.id,
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 应用设置
            applySet(row) {
                console.log('应用设置')
                this.applySetVisible = true
                this.applyId = row.id
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/apply/ApplyManage.vue